function isEnabled(value) {
  return ["1", "true", "yes", "on"].includes(
    String(value || "")
      .trim()
      .toLowerCase(),
  );
}

export const SHOW_FULL_RESULTS = isEnabled(
  process.env.SHOW_FULL_RESULTS ?? process.env.REACT_APP_SHOW_FULL_RESULTS,
);
